import * as Sentry from '@sentry/react';

const CONFIG = {
  dsn: import.meta.env.VITE_SENTRY_DNS,
  tracesSampleRate: 1.0,
  environment: import.meta.env.MODE,
  ignoreErrors: [
    'Non-Error exception captured',
    'Non-Error promise rejection captured',
  ],
  beforeSend(event) {
    if (
      event !== undefined &&
      event.exception !== undefined &&
      event.exception.values !== undefined &&
      event.exception.values.length == 1
    ) {
      const error = event.exception.values[0];
      if (
        error.type.includes('UnhandledRejection') ||
        error.value.includes('Non-Error promise')
      ) {
        return null;
      }
      return event;
    }
  },
};

export default {
  init() {
    if (import.meta.env.MODE !== 'production') {
      return false;
    }
    if (import.meta.env.VITE_SENTRY_RELEASE) {
      CONFIG.release = import.meta.env.VITE_SENTRY_RELEASE;
    }
    return Sentry.init(CONFIG);
  },
};
